module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/sg/sg_a_una_tinta-aa329aff04d80c6cfbd3cdd5df6d4c93.svg";